import React from 'react';

const Container = ({ children }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
      {children}
    </div>
  );
};

export default Container;
